/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SwiperHomeHeader.vue?vue&type=template&id=36dead03&scoped=true"
import script from "./SwiperHomeHeader.vue?vue&type=script&lang=js"
export * from "./SwiperHomeHeader.vue?vue&type=script&lang=js"
import style0 from "./SwiperHomeHeader.vue?vue&type=style&index=0&id=36dead03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dead03",
  null
  
)

export default component.exports